import { render, staticRenderFns } from "./DatePickerNoSchema.vue?vue&type=template&id=c05c0154&"
import script from "./DatePickerNoSchema.vue?vue&type=script&lang=js&"
export * from "./DatePickerNoSchema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports